import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export default {
    install: (app, options) => {
        if (!options) {
            throw new Error('[Vue-Echo] cannot locate options');
        }

        if (typeof options !== 'object') {
            throw new Error('[Vue-Echo] cannot initiate options');
        }

        if (typeof options.socketId === 'function') {
            app.config.globalProperties.$echo = options;
        } else {
            app.config.globalProperties.$echo = new Echo(options);
        }

        // Avoid "Page entered Back-Forward Cache" WebSocket console errors.
        const pusher = app.config.globalProperties.$echo?.connector?.pusher;
        if (pusher) {
            window.addEventListener('pagehide', () => {
                if (pusher.connection?.state !== 'disconnected') {
                    pusher.disconnect();
                }
            });
            window.addEventListener('pageshow', event => {
                if (event.persisted && pusher.connection?.state === 'disconnected') {
                    pusher.connect();
                }
            });
        }
    },
};
